import React, { lazy, Suspense } from 'react'
import styled, { keyframes } from 'styled-components'
// import CoverVideo from '../CoverVideo'
// import TypeWriterText from '../TypeWriterText'
import RoundTextBlack from '../../assets/Rounded-Text-Black.png';
import Loading from '../Loading';
import rocket from '../../assets/rocket-ezgif.com-rotate.gif';
import rocketdown from '../../assets/timeline_img.png';
import FlareLogo from '../../assets/flarelogo.png';
const CoverVideo = lazy(() => import('../CoverVideo'));
const TypeWriterText = lazy(() => import('../TypeWriterText'));

const Section = styled.section`
min-height: ${props => `calc(100vh - ${props.theme.navHeight})`};
width: 100vw;
position: relative;
background-image: url(${rocket});
background-size: cover;
background-position: center;
background-repeat: no-repeat;

@media (max-width: 48em) {
  background-size: contain; // Ensures the whole image is visible
  background-position: top center; // Adjust this if you need to focus on a particular part
}
`;

const Container = styled.div`
width: 75%;
min-height: 80vh;
margin: 0 auto;


display: flex;
justify-content: center;
align-items: center;

@media (max-width: 64em) {
  width: 85%;
}
@media (max-width: 48em) {
  flex-direction: column-reverse;
  width: 100%;
  &>*:first-child{
    width: 100%;
    margin-top: 2rem;
  }
}
`
const Box = styled.div`
width: 50%;
height: 100%;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
`
const rotate = keyframes`
100%{
  transform: rotate(1turn);
}
`
const Round = styled.div`
position: absolute;
bottom: 2rem;
right: 90%;
width: 6rem;
height: 6rem;
border: 1px solid ${props => props.theme.text};
border-radius: 50%;

img{
  width: 100%;
  height: auto;
  
  animation: ${rotate} 6s linear infinite reverse ;
}
@media (max-width: 64em) {
  position: none;
}
@media (max-width: 48em) {
  
  right: 1rem;
}
`



const Circle = styled.span`
width: 3rem;
height: 3rem;
display: flex;
justify-content: center;
align-items: center;
border-radius: 50%;

position: absolute;
top: 50%;
left: 50%;
transform: translate(-50%,-50%);

background-color: ${props => props.theme.text};
color: ${props => props.theme.body};
font-size:${props => props.theme.fontxl};

@media (max-width: 64em) {
  width: 2rem;
  height: 2rem;
font-size:${props => props.theme.fontlg};

}

`
const Logo = styled.img`
  position: absolute; // Changed to 'fixed' to ensure it stays in place on scroll
  top: 1rem; // Adjust top spacing
  right: 1rem; // Adjust right spacing for desktop view
  width: 15rem; // Adjust the size of the logo as needed
  height: auto;

  @media (max-width: 48em) {
    position: absolute; // Change back to 'absolute' for mobile view
  }
`;


const Home = () => {
  return (
    <Section id="home">
      <Container>
       

        <Box>
        
        <Suspense fallback={<Loading />}>
          <CoverVideo /></Suspense>
         
        
       
        </Box>
        <Logo src={FlareLogo} alt="Flare Logo" /> {/* This line adds the logo */}

        <Box>
        <Suspense fallback={<Loading />}>
          <TypeWriterText /></Suspense> 
      </Box>

        
        <Round>
        <Circle>
        <img src={rocketdown} alt="Rocket" /> {/* This image will not rotate */}
        </Circle>
          <img width={500} height={400} src={RoundTextBlack} alt="NFT" />
        </Round>

      </Container>
    </Section>
  )
}

export default Home